import { render, staticRenderFns } from "./TaxList.vue?vue&type=template&id=c1a469b2"
import script from "./TaxList.vue?vue&type=script&lang=js"
export * from "./TaxList.vue?vue&type=script&lang=js"
import style0 from "./TaxList.vue?vue&type=style&index=0&id=c1a469b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports